import Can from 'components/Can/Can';
import {
	ALERTAS_PERMISSIONS, BOLETIM_INFORMATIVO_PERMISSIONS, CENTRAL_DOACOES_PERMISSIONS, COMANDO_INCIDENTES_PERMISSIONS, DACA_PERMISSIONS, PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS, PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS, PLANO_DETALHADO_PERMISSIONS, PLANO_TRABALHO_PERMISSIONS, PRESTACAO_CONTAS_PERMISSIONS, RELATORIO_VISTORIA_PERMISSIONS, DASHBOARD_PERMISSIONS,
} from 'constants/index';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Title from '../../../components/Title/title.component';
import prestacaoContasService from '../../../services/prestacaoContasService';
import { BagdeStyle, CardStyle, HomeDivStyle } from './home.style';

const getURL = (url) => {
	return `${process.env.REACT_APP_STAGE}${url}`
}

class Home extends Component {
	state = {
		countPrestacaoContas: 0,
	};

	componentDidMount() {
		this.contaProcessos().then(res => this.setState({ countPrestacaoContas: res.data }));
	}

	contaProcessos = async () => prestacaoContasService.countPrestacaoContas();

	render() {
		const { countPrestacaoContas } = this.state;
		return (
			<Fragment>
				<Title>
					<div className='row'>
						<div className='col-10'>Módulos</div>
					</div>
				</Title>

				<HomeDivStyle className='container-fluid'>
					<CardStyle>
						<div className='row'>
							<Can
								perform={ALERTAS_PERMISSIONS.VISUALIZAR}
								yes={() => (
									<div className='col-md-3'>
										<Link
											id='alertas'
											to='/alertas'
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-engine-warning mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Alertas
													</h5>
												</div>
											</div>
										</Link>
									</div>
								)}
								no={() => null}
							/>
							<Can
								perform={DACA_PERMISSIONS.VISUALIZAR}
								yes={() => (
									<div className='col-md-3'>
										<Link
											id='daca'
											to='/listadaca'
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-box-alt mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														DACA
													</h5>
												</div>
											</div>
										</Link>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR}
								yes={() => (
									<div className='col-md-3'>
										<Link
											id='centralDoacoes'
											to='/centralDoacoes/listaDoacoes'
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-donate mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Central de doações
													</h5>
												</div>
											</div>
										</Link>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={
									PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR
								}
								yes={() => (
									<div className='col-md-3'>
										<Link
											id='prestacaoContas'
											to='/prestacaoContas'
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal text-center fa-file-invoice-dollar mt-4 mb-4' />
												<BagdeStyle className='badge badge-pill badge-dark ml-2'>
													{countPrestacaoContas}
												</BagdeStyle>
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Prestação de Contas
													</h5>
												</div>
											</div>
										</Link>
									</div>
								)}
								no={() => null}
							/>
							<Can
								perform={[
									PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS.VISUALIZAR_ESTADUAL,
									PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS.VISUALIZAR_MUNICIPAL,
									PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS.VISUALIZAR_REGIONAL]}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='planoContigencia'
											href={getURL('plano-contingencia')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-clipboard-list-check mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Plano de Contingência
														Municipal
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={
									PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS.VISUALIZAR
								}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='planoContigenciaEstadual'
											href={getURL('plano-contingencia-estadual')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-clipboard-list-check mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Plano de Contingência
														Estadual
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={
									RELATORIO_VISTORIA_PERMISSIONS.VISUALIZAR
								}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='modulo06'
											href={getURL('modulo06/index.html')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-file-chart-pie mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Relatório de Vistoria
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={[
									PLANO_DETALHADO_PERMISSIONS.VISUALIZAR_ESTADUAL,
									PLANO_DETALHADO_PERMISSIONS.VISUALIZAR_MUNICIPAL,
									PLANO_DETALHADO_PERMISSIONS.VISUALIZAR_REGIONAL]}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='modulo07'
											href={getURL('modulo07/index.html')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-hands-helping mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Plano Detalhado de
														Resposta
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={[
									PLANO_TRABALHO_PERMISSIONS.VISUALIZAR_ESTADUAL,
									PLANO_TRABALHO_PERMISSIONS.VISUALIZAR_MUNICIPAL,
									PLANO_TRABALHO_PERMISSIONS.VISUALIZAR_REGIONAL]}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='modulo08'
											href={getURL('modulo08/index.html')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-forklift mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Plano de Trabalho
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={
									BOLETIM_INFORMATIVO_PERMISSIONS.VISUALIZAR_NOTICIA
								}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='modulo13'
											href={getURL('modulo13/index.html')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-newspaper mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Comunicação Social
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={
									COMANDO_INCIDENTES_PERMISSIONS.VISUALIZAR
								}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='modulo05'
											href={getURL('modulo05/index.html')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-user-injured mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Sistema de Comando de
														Incidentes
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>

							<Can
								perform={[
									DASHBOARD_PERMISSIONS.VISUALIZAR_PRIVADO,
									DASHBOARD_PERMISSIONS.VISUALIZAR_PUBLICO
								]}
								yes={() => (
									<div className='col-md-3'>
										<a
											id='modulo14'
											href={getURL('modulo14/index.html')}
											className='mr-3'
										>
											<div className='card d-flex justify-content-end align-items-center'>
												<i className='fal fa-chart-pie mt-4 mb-4' />
												<div className='card-body text-center d-flex justify-content-center align-items-center'>
													<h5 className='card-title'>
														Painel de Controle
													</h5>
												</div>
											</div>
										</a>
									</div>
								)}
								no={() => null}
							/>
						</div>
					</CardStyle>
				</HomeDivStyle>
			</Fragment>
		);
	}
}

export default Home;
